import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';

import thunk from 'redux-thunk'
import api from '../middleware/api'
import rootReducer from '../redux';


const configureStore = (history, preloadedState) => {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(
        thunk,
        api,
        routerMiddleware(history)
      ),
    )
  )

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../redux', () => {
      const nextRootReducer = require('../redux').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store;
}

export default configureStore


// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js